import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IAttributes } from 'src/app/models/IAttributes';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { RxService } from 'src/app/Services/NewVisitNote/rx.service';
import { ToastrService } from 'ngx-toastr';

@Component({
   selector: 'app-medication-status',
  templateUrl: './medication-status.component.html',
  styleUrls: ['./medication-status.component.css']

})
export class MedicationStatusComponent implements OnInit {

  AddMedicationStatusForm: FormGroup;
  dataSource: IAttributes[] = [];
  lstattrbutes: IAttributes[] = [];
  listName: string = "";
  Isadded: boolean = false;
  message: string
  filteredOptions: Observable<IAttributes[]>;
public staff: IAttributes[] = [];
  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<MedicationStatusComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IAttributes[], public dialog: MatDialog, private sharedService: SharedService, private rxservice: RxService, private toastr: ToastrService) { }

  ngOnInit() {
    this.AddMedicationStatusForm = this.fb.group({
      attributeId: ['']
    });
   this.medicationStatusDropDownBinding();
  
  }
 medicationStatusDropDownBinding() {
   var attrType=66;
     this.sharedService.getAttributesById(attrType).subscribe((data: IAttributes[]) => {
         // this.dataSource = data;
          this.dataSource = data.filter(c => c.attributeName ==="Inactive" ||
           c.attributeName ==="Discontinued" || c.attributeName ==="Completed" || c.attributeName==="Ineffective" || c.attributeName === "Very Urgent");
        
        
    })    
 }
  updateMedication(){
     var status = this.AddMedicationStatusForm.value.attributeId;
     this.dialogRef.close(status);
  }
  onCancelClick(): void {
    this.dialogRef.close();
  }

}
